import { TrackingEvent, TrackingReportType } from '../types/index';

const MODULE_NAME_QUERY_PARAM = 'esg';
const TEALIUM_TIMEOUT = 1000;

declare global {
  interface Window {
    IS24?: {
      TEALIUM: {
        tracking: {
          report: (event: TrackingEvent, type?: TrackingReportType) => void;
        };
      };
    };
  }
}

export const constructTrackingScriptUrl = () => {
  return `https://tracking.${process.env.IS24_HOST}/tr.js?cP--countername=is24.de.esg.modernization-calculator.eek&cP--svc_module_name=${MODULE_NAME_QUERY_PARAM}&initialPageView=false`;
};

export const initTracking = () => {
  const scriptSrc = constructTrackingScriptUrl();

  if (scriptSrc) {
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.id = 'tealium-script';
    script.async = true;
    document.body.appendChild(script);
  }
};

export function isTrackingLoaded() {
  return window.IS24 !== undefined && window.IS24.TEALIUM !== undefined && window.IS24.TEALIUM.tracking !== undefined;
}

export function reportEvent(event: TrackingEvent, retryCount = 0) {
  if (isTrackingLoaded()) {
    window.IS24?.TEALIUM.tracking.report(event);
  } else {
    if (retryCount > 0) {
      setTimeout(() => reportEvent(event, retryCount - 1), TEALIUM_TIMEOUT);
    }
  }
}

export const reportViewEstimateClickCtaEvent = () => {
  reportEvent({
    evt_ga_category: 'expose',
    evt_ga_action: 'eek_estimation',
    evt_ga_label: 'cta_click',
    event_name: 'cta_click',
    event_product: 'search',
    event_parameter_1: 'eek_estimation',
  });
};

export const reportMessageClickCtaEvent = () => {
  reportEvent({
    evt_ga_category: 'expose',
    evt_ga_action: 'eek_estimation',
    evt_ga_label: 'cta_click',
    event_name: 'cta_click',
    event_product: 'search',
    event_parameter_1: 'eek_estimation',
    event_parameter_2: 'contact_request',
  });
};

export const reportModernizationCostsCalculionEvent = () => {
  reportEvent({
    evt_ga_category: 'expose',
    evt_ga_action: 'modernization_calculator',
    evt_ga_label: 'button_click',
    event_name: 'button_click',
    event_product: 'search',
    event_parameter_1: 'cta_mordernization_calculator',
  });
};

export const reportModalModernizationCostsCalculionEvent = () => {
  reportEvent({
    evt_ga_category: 'contact',
    evt_ga_action: 'modernization_calculator',
    evt_ga_label: 'button_click',
    event_name: 'button_click',
    event_product: 'search',
    event_parameter_1: 'cta_mordernization_calculator',
    event_parameter_2: 'eek_estimation',
  });
};
